<template>
  <div v-if="brandConfig" 
    class="register-client flex flex-center q-pa-md"
    :style="$q.screen.md || $q.screen.lg || $q.screen.xl ? 'margin-top: 50px' : ''"
    >
    <q-card flat bordered :style="$q.screen.md || $q.screen.lg || $q.screen.xl ? 'max-width: 900px' : ''">
      <q-card-section class="q-pa-sm" style="display: flex; flex-direction: row; align-items: baseline; justify-content: center;">
        <q-avatar square size="75px" style="width: auto;">
          <img alt="logo-brand" width="100%" :src="brandConfig.brandImage('logos', 'img-logo', 'png')" />
        </q-avatar>    
      </q-card-section>
      <q-card-section class="q-pa-sm" style="display: flex; flex-direction: row; align-items: baseline; justify-content: flex-start;">
        <q-avatar class="q-pl-sm" square size="md">
          <q-icon color="black" name="border_color" size="sm" />
        </q-avatar>
        <q-list>
          <q-item-label class="q-pl-md text-subtitle1 text-weight-bolder">Cadastre-se</q-item-label>          
        </q-list>        
      </q-card-section>
      <q-separator inset size="2px" />
      <q-card-section class="q-pa-sm">
        <q-form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12 col-md-6">
              <q-card flat>
                <q-card-section class="q-pa-sm" style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start;">
                  <q-avatar size="sm" >
                    <q-icon color="black" name="person" size="sm" />
                  </q-avatar>
                  <q-item-label class="q-pl-sm text-bold">Seus dados</q-item-label>
                </q-card-section>
                <q-card-section class="q-pa-sm">
                  <div class="row q-col-gutter-x-sm">
                    <div class="col-12 col-md-6">
                      <span>Nome Completo</span>
                      <q-input
                        class="full-width"
                        color="black"
                        outlined dense maxlength="240"
                        v-model="form.nome"                        
                        :error="r$.form.nome.$error"
                        :error-message="r$.form.nome.$error ? r$.form.nome.$errors[0] : ''"
                      />
                    </div>
                    <div class="col-6">
                      <span>CPF</span>
                      <q-input
                        class="full-width"
                        color="black"
                        outlined dense
                        mask="###.###.###-##"
                        v-model="form.cpf"                                                
                        :error="r$.form.cpf.$error"
                        :error-message="r$.form.cpf.$error ? r$.form.cpf.$errors[0] : ''"
                      />
                    </div>
                    <div class="col-6">
                      <span>Data de nascimento</span>                
                      <q-input
                        class="full-width"
                        color="black"
                        v-model="form.dataNascimento"                
                        outlined dense
                        mask="##/##/####"
                        :error="r$.form.dataNascimento.$error"
                        :error-message="r$.form.dataNascimento.$error ? r$.form.dataNascimento.$errors[0] : ''"
                      />                 
                    </div>
                    <div class="col-12 col-md-6">
                      <span>Telefone / WhatsApp</span>
                      <q-input
                        class="full-width"
                        color="black"
                        outlined dense
                        mask="(##)#####-####"
                        unmasked-value
                        v-model="form.telefoneCelular"                                                
                        :error="r$.form.telefoneCelular.$error"
                        :error-message="r$.form.telefoneCelular.$error ? r$.form.telefoneCelular.$errors[0] : ''"
                      />
                    </div>
                    <div class="col-12 col-md-6">
                      <span>Email</span>
                      <q-input
                        class="full-width"
                        color="black"
                        outlined dense maxlength="240"
                        v-model="form.email"                        
                        :error="r$.form.email.$error"
                        :error-message="r$.form.email.$error ? r$.form.email.$errors[0] : ''"
                      />
                    </div>
                  </div>
                </q-card-section>
              </q-card>    
            </div> 
            <div class="col-12 col-md-6">
              <q-card flat>                                
                <q-card-section class="q-pa-sm" style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start;">
                  <q-avatar size="sm" >
                    <q-icon color="black" name="pin_drop" size="sm" />
                  </q-avatar>
                  <q-item-label class="q-pl-sm text-bold">Seu endereço</q-item-label>
                </q-card-section>
                <q-card-section class="q-pa-sm">
                  <div class="row q-col-gutter-x-sm">
                    <div class="col-8">
                      <span>CEP</span>
                      <q-input
                        class="full-width"
                        color="black"
                        outlined dense
                        mask="##.###-###"
                        v-model="form.cep"
                        :error="r$.form.cep.$error"
                        :error-message="r$.form.cep.$error ? r$.form.cep.$errors[0] : ''"
                        @blur="getCep"
                      />
                    </div>
                    <div class="col-4">
                      <span>Estado/UF</span>                      
                      <q-select
                        :disable="pesCepLoading"                                     
                        color="black"
                        dense outlined
                        v-model="form.estadoUf"
                        :options="listaEstados"
                        emit-value
                        map-options
                        options-dense
                        :error="r$.form.estadoUf.$error"
                        :error-message="r$.form.estadoUf.$error ? r$.form.estadoUf.$errors[0] : ''"
                      />
                    </div>         
                    <div class="col-12">
                      <span>Cidade</span>
                      <q-input
                        :disable="pesCepLoading"
                        class="full-width"
                        color="black"
                        outlined dense maxlength="60"
                        v-model="form.cidade"
                        :error="r$.form.cidade.$error"
                        :error-message="r$.form.cidade.$error ? r$.form.cidade.$errors[0] : ''"
                      />
                    </div>
                    <div class="col-12">
                      <span>Bairro</span>
                      <q-input
                        class="full-width"
                        color="black"
                        outlined dense maxlength="72"
                        v-model="form.bairro"
                        :error="r$.form.bairro.$error"
                        :error-message="r$.form.bairro.$error ? r$.form.bairro.$errors[0] : ''"
                      />
                    </div>
                    <div class="col-12">
                      <span>Endereço - Rua</span>
                      <q-input
                        class="full-width"
                        color="black"
                        outlined dense maxlength="100"
                        v-model="form.endereco"
                        :error="r$.form.endereco.$error"
                        :error-message="r$.form.endereco.$error ? r$.form.endereco.$errors[0] : ''"
                      />
                    </div>       
                    <div class="col-4">
                      <span>Numero</span>
                      <q-input
                        class="full-width"
                        color="black"
                        outlined dense
                        mask="##########"
                        v-model="form.enderecoNumero"
                        :error="r$.form.enderecoNumero.$error"
                        :error-message="r$.form.enderecoNumero.$error ? r$.form.enderecoNumero.$errors[0] : ''"
                      />
                    </div>
                    <div class="col-8">
                      <span>Complemento</span>
                      <q-input
                        class="full-width"
                        color="black"
                        outlined dense
                        v-model="form.complemento"
                        :error="r$.form.complemento.$error"
                        :error-message="r$.form.complemento.$error ? r$.form.complemento.$errors[0] : ''"
                      />
                    </div>    
                  </div>
                </q-card-section>
              </q-card>    
            </div>
            <div class="col-12 flex flex-center  q-px-sm">
              <div 
                class="q-pt-md q-pb-md"
                :class="$q.screen.xs || $q.screen.sm ? 'full-width' : ''"
                :style="$q.screen.md || $q.screen.lg || $q.screen.xl ? 'width: 50%' : '100%'">
                <q-btn
                  type="submit"
                  color="black"
                  icon-right="check_circle"
                  label="Confirmar"
                  class="full-width"
                  :loading="insertLoading"              
                />
              </div>              
            </div>           
          </div>                                                 
        </q-form>
      </q-card-section>   
    </q-card>

  <q-dialog
    persistent
    :maximized="$q.screen.xs || $q.screen.sm"
    transition-show="scale"
    transition-hide="scale"
    v-model="showSuccessModal"
  >
    <q-card class="column no-wrap" :style="$q.screen.md || $q.screen.lg || $q.screen.xl ? 'max-width: 700px' : ''">
      <q-card-section class="text-center q-pa-sm">
        <q-avatar square size="75px">
          <img alt="logo-brand" width="100%" :src="brandConfig.brandImage('logos', 'img-logo', 'png')" />
        </q-avatar>
      </q-card-section>
      <q-card-section style="height: calc(100vh - 350px)" class="column items-center q-px-lg">        
        <q-icon name="check_circle" :color="brandConfig.brandColor()" size="75px" />
        <span class="text-h6 text-weight-bolder text-center">
          Cadastro Realizado com Sucesso!
        </span>
        <span class="text-body1 text-center text-grey-9 q-mb-sm">
          Obrigado por se cadastrar, 
          <span class="text-bold text-black">{{ form.nome.split(' ')[0] }}</span>!
        </span>
      </q-card-section>
      <q-card-actions align="center" class="q-pa-none">
        <div class="column full-width items-center q-gutter-md q-px-xl q-pb-md">
          <a :href="brandConfig.brandSiteUrl" target="_blank" class="full-width" style="display: block;">
            <q-btn label="IR PARA A LOJA" color="black" outline class="q-px-xl full-width"></q-btn>
          </a>                                            
          <q-btn label="FECHAR" color="black" outline class="q-px-xl full-width" v-close-popup @click="clearData" />
        </div>
        <div class="column full-width items-center q-gutter-md" style="height: 200px;">          
          <div class="social-media q-pt-xl" style="display: flex; gap: 20px;">
            <a :href="brandConfig.brandSocialMedia.facebook()" target="_blank" class="text-grey-9">
              <q-icon size="40px">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"/>
                </svg>
              </q-icon>
            </a>
            <a :href="brandConfig.brandSocialMedia.instagram()" target="_blank" class="text-grey-9">
              <q-icon size="40px">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                </svg>
              </q-icon>
            </a>
            <a :href="brandConfig.brandSocialMedia.linkedin()" target="_blank" class="text-grey-9">
              <q-icon size="40px">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/>
                </svg>
              </q-icon>
            </a>
            <a :href="brandConfig.brandSocialMedia.youtube()" target="_blank" class="text-grey-9">
              <q-icon size="40px">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/>
                </svg>
              </q-icon>
            </a>
          </div>          
        </div>
      </q-card-actions>
    </q-card>
  </q-dialog>
  </div>
</template>

<script>
import { ref, reactive, computed } from 'vue';
import { mapActions } from 'vuex'
import { defineRegleConfig } from '@regle/core';
import { withMessage, required, email, minLength } from '@regle/rules';
import { validateCPF, validatePhone } from 'validations-br';
import { helperNotify } from '@/helpers/notify';
import { brandConfig as brandConfigHelper } from '@/helpers/brandConfig'

const sanitizeString = (val) => val.replace(/\D/g, '');

const isValidBRDate = (value) => {
  const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  if (!regex.test(value)) return false;
  const [day, month, year] = value.split("/").map(Number);
  const dateObj = new Date(year, month - 1, day);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    dateObj.getDate() === day &&
    dateObj.getMonth() === month - 1 &&
    dateObj.getFullYear() === year &&
    dateObj <= today
  );
};

const isvalidCEP = (cep) => cep.replace(/\D/g, '').length === 8;

const { useRegle: useCustomRegle } = defineRegleConfig({
  rules: () => ({
    required: withMessage(required, 'Campo obrigatório'),
    email: withMessage(email, 'Email é inválido'),
    minLength: withMessage(minLength, ({ $params: [min] }) => {
      return `Deve ter pelo menos ${min} caracteres`;
    }),
    validateCPF: withMessage(validateCPF, 'CPF é inválido'),
    isValidBRDate: withMessage(isValidBRDate, 'Data é inválida'),
    validatePhone: withMessage(validatePhone, 'Telefone é inválido'),
    isvalidCEP: withMessage(isvalidCEP, 'CEP é inválido'),
  })
})

export default {
  name: 'Campaign',

  setup () {
    const currentBrandConfig = brandConfigHelper;

    const form = reactive({
      nome: '',
      cpf: '',
      dataNascimento: '',
      telefoneCelular: '', 
      email: '',
      cep: '',
      estadoUf: '',
      cidade: '',
      bairro: '',
      endereco: '',
      enderecoNumero: '',
      complemento: ''
    });

    const rules = computed(() => ({
      form: {
        nome: { required, minLength: minLength(5) },
        cpf: {
          required,
          validateCPF:(cpf) => {
            return validateCPF(cpf)
          }
        },
        dataNascimento: {
          required,
          isValidBRDate : (dataNascimento) => {
            return isValidBRDate(dataNascimento)
          }
        },
        telefoneCelular: { 
          required,
          minLength: minLength(11),
          validatePhone : (telefoneCelular) => {
            return validatePhone(telefoneCelular)
          }
        },
        email: { required, email },
        cep: { 
          required ,
          isvalidCEP : (cep) => {
            return isvalidCEP(cep)
          }
        },
        estadoUf: { required },
        cidade: { required },
        bairro: { required },
        endereco: { required },
        enderecoNumero: { required }
      }              
    }));

    const pesCepLoading = ref(false)
    const insertLoading = ref(false)
    const showSuccessModal = ref(false)
    const imgMainContainer = ref({})

    const listaEstados = [
      'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 
      'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 
      'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
    ]

    const { r$ } = useCustomRegle({ form }, rules);

    return {
      brandConfig: currentBrandConfig,
      form,
      r$,
      insertLoading,
      pesCepLoading,
      listaEstados,
      showSuccessModal,
      imgMainContainer 
    };
  },

  computed: {
    qrcode: function () {
      return this.$route.params.qrcode
    },    
  },

  methods: {
    ...mapActions('campaign',['insertConsumerB2C', 'pesqCep']),

    clearData() {
      Object.keys(this.form).forEach(key => this.form[key] = '');
      this.r$.$reset()
      this.insertLoading = false
      this.pesCepLoading = false
    },

    async getCep() {
      const sanitizedCep = sanitizeString(this.form.cep)
      if (sanitizedCep.length !== 8) return

      this.pesCepLoading = true     
      try {
        const resp = await this.pesqCep(sanitizedCep)
        if (resp.total) {
          this.form.estadoUf = resp.ceps[0].UF_CODIGO
          this.form.cidade = resp.ceps[0].LOC_NOME          
          this.form.endereco = resp.ceps[0].LOG_NOME
        } else {          
          helperNotify.error('Erro', `Cep ${this.form.cep} inválido`);
          ['cep', 'estadoUf', 'cidade', 'endereco'].forEach(k => this.form[k] = '')
        }
      } catch (err) {        
        helperNotify.error(
          'Erro',
          err?.data?.details 
              ? `${err?.data?.details}`
              : err?.data?.detail 
                  ? err?.data?.detail 
                    : err?.data?.message 
                      ? err?.data?.message : 'Erro ao buscar o cep',
        );
        ['cep', 'estadoUf', 'cidade', 'endereco'].forEach(k => this.form[k] = '')
      } finally {
        this.pesCepLoading = false
      }
    },

    async handleSubmit() {
      const { valid } = await this.r$.$validate();
      if(valid){
        try {
          this.insertLoading = true          
          await this.insertConsumerB2C({
            ...this.form,
            conOrigem: "CAMPANHA",
            marcaId: this.brandConfig.brandCodeSac(),
            qrcode: this.qrcode,
            cpf: sanitizeString(this.form.cpf),
            cep: sanitizeString(this.form.cep),
            telefoneCelular: sanitizeString(this.form.telefoneCelular).replace(/^(\d{2})(\d+)/, '($1)$2')
          })
          this.showSuccessModal = true
        } catch (err) {
          helperNotify.error(
              'Erro',
              err?.data?.details 
                  ? `${err?.data?.details}`
                  : err?.data?.detail 
                      ? err?.data?.detail 
                        : err?.data?.message 
                          ? err?.data?.message : 'Erro ao efetuar o cadastro',
          );
        } finally {
          this.insertLoading = false
        }
      } else {
        helperNotify.error('Erro', 'Por favor, corrija os erros no formulário antes de enviar.');
      }
    }
  },
  
  mounted() {
    this.clearData()
    if (this.brandConfig && typeof this.brandConfig.brandColor === 'function') {
      const color = this.brandConfig.brandColor();
      document.documentElement.style.setProperty('--theme-color', color);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
